import type { ReactNode } from "react"
import { router } from "@inertiajs/react"
import { useEffect } from "react"
import { toast } from "sonner"
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar"
import { TooltipProvider } from "@/components/ui/tooltip"
import { Toaster } from "@/components/ui/sonner"
import { PageHeaderProvider } from "@/hooks/use-page-header"
import { AppSidebar } from "@/components/app-sidebar"
import { AppHeader } from "@/components/app-header"
import { ImpersonationBanner } from "@/components/impersonation-banner"
import type { FlashData } from "@/types"

function FlashToasts() {
  useEffect(() => {
    return router.on("success", (event) => {
      const flash = event.detail.page.props.flash as FlashData | undefined
      if (flash?.notice) toast.success(flash.notice)
      if (flash?.alert) toast.error(flash.alert)
    })
  }, [])

  return null
}

export function AppLayout({ children, noPadding }: { children: ReactNode; noPadding?: boolean }) {
  return (
    <TooltipProvider>
      <SidebarProvider>
        <PageHeaderProvider>
          <AppSidebar />
          <SidebarInset className="flex h-screen flex-col overflow-hidden">
            <ImpersonationBanner />
            <AppHeader />
            <main className={`flex-1 overflow-y-auto ${noPadding ? "" : "[scrollbar-gutter:stable] p-6"}`}>
              {children}
            </main>
          </SidebarInset>
          <FlashToasts />
          <Toaster position="top-center" richColors />
        </PageHeaderProvider>
      </SidebarProvider>
    </TooltipProvider>
  )
}
